export default `
precision highp float;
varying vec2 vUv;

uniform sampler2D texture;
uniform float time;

uniform vec2 cameraPosition;
uniform float cameraScale;
 

const float TENDRIL_COUNT = 8.;
const float MAX_LENGTH = 0.5;
const float SPEED_SCALER = 0.03;

float random (float x) {
    return fract(sin(x)*100000.0);
}

vec4 mainImage(vec2 uv, float iTime)
{
    float cilia; 
        
    //Get "bands" each is a cilia
    float bandNumber = floor(uv.y * TENDRIL_COUNT);
    float band = mod(uv.y * TENDRIL_COUNT , 1.);
    
    //Introduce some per band variation
    float randomPerBand = random(bandNumber + 2.); //0 and 1 values cause weired results
    float randomPerBand2 = random(bandNumber + 2. + 11.); //0 and 1 values cause weired results

    //Vary length
    float halfRand = randomPerBand * MAX_LENGTH;
    float distanceToEnd = max(0.0, halfRand - uv.x) / halfRand;

    //Curve up and down over time, randomized by band
    float curve = pow(1. - distanceToEnd, 2.);
    curve = mix(0., curve, cos((iTime + randomPerBand2) * SPEED_SCALER) );
        
    //Center around the "curve" value, to get the shape of the tendril
    float bandNormalized = (band * 2.0) - 1.0 - curve;
    float centered = 1. - abs(bandNormalized);
    
    //Taper and fade edges
    float varyWidth = max(0.5, randomPerBand2) * 7.;
    centered -=  1. - (centered * varyWidth * distanceToEnd);

    cilia = max(0., centered);

    //Output to screen
    float depth = cilia/4.0; //Give them a low depth so they will be out of focus
    return vec4(vec3(depth, depth, 0.0), pow(cilia, 2.));

    // float test = centered;
    // return vec4(test, test, test, 1.0);
}

void main() {
    float x= vUv.x;
    float y= vUv.y;

	vec4 tex = texture2D(texture, vec2(x, y));

	if (tex.a <= 0.0) {
		gl_FragColor = vec4(0.0);
		return;
	}
    float speed = tex.z;
	gl_FragColor = mainImage(vec2(tex.x, tex.y), time * speed);
}`;